import React from "react";

function NotFound404() {
  return (
    <div className="container mx-auto flex justify-center items-center gap-5 p-5 mb-10 md:p-8 lg:px-15">
      <div className="w-3/4">
      <div className="font-bold text-[100px] leading-[100px] md:text-[200px] md:leading-[200px]">404</div>
      <div className="font-bold text-[30px] md:text-[60px]">Page Not Found</div>
      <p className="font-normal text-lg mb-4">
        We’re sorry, the page you requested could not be found. Please go back
        to the homepage!
      </p>
            <a href="/">
              <button
                type="submit"
                className="rounded justify-center flex gap-1 text-sm font-semibold bg-primary text-white hover:bg-[#100a55e5] px-7 py-3.5"
              >
               Go Home
              </button>
            </a>
            </div>
    </div>
  );
}

export default NotFound404;
